import React from "react";

const IncludeSection = ({
  mainImage,
  heading,
  items,
}) => {
  return (
    <section className="relative py-16 md:py-20 bg-[#F7F1EA] overflow-hidden">
      {/* BG GLOWS */}
      <div
        className="
          absolute
          top-0
          left-0
          w-72
          h-72
          bg-[#E9CDB2]/30
          blur-3xl
          rounded-full
        "
      />

      <div
        className="
          absolute
          bottom-0
          right-0
          w-72
          h-72
          bg-[#DDBA99]/20
          blur-3xl
          rounded-full
        "
      />

      <div className="relative max-w-[1280px] mx-auto px-6">
        {/* HEADING */}
        <div className="text-center mb-12">
          <div
            className="
              inline-flex
              items-center
              px-4
              py-2
              rounded-full
              bg-[#FFF4E8]
              border
              border-[#F3DDC7]
              text-primary
              text-[11px]
              tracking-[.18em]
              uppercase
              font-medium
              mb-4
            "
          >
            Retreat Experience
          </div>

          <h2
            className="
              text-3xl
              md:text-5xl
              font-bold
              text-secondary
              leading-tight
            "
          >
            {heading}
          </h2>
        </div>

        {/* MAIN GRID */}
        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-2
            gap-8
            items-stretch
          "
        >
          {/* IMAGE CARD */}
          <div
            className="
              group
              relative
              overflow-hidden
              rounded-[34px]
              min-h-[620px]
              shadow-[0_25px_60px_rgba(20,10,0,.10)]
            "
          >
            <img
              src={mainImage}
              alt={heading}
              className="
                w-full
                h-full
                object-cover
                transition-transform
                duration-700
                group-hover:scale-105
              "
            />

            <div
              className="
                absolute
                inset-0
                bg-gradient-to-t
                from-black/70
                via-black/10
                to-transparent
              "
            />

            {/* FLOATING CONTENT */}
            <div className="absolute bottom-6 left-6 right-6">
              <div
                className="
                  rounded-[28px]
                  bg-white/10
                  backdrop-blur-2xl
                  border
                  border-white/10
                  p-6
                "
              >
                <h3
                  className="
                    text-2xl
                    md:text-3xl
                    font-bold
                    text-white
                    mb-3
                  "
                >
                  What's Included
                </h3>

                <p
                  className="
                    text-white/75
                    text-sm
                    leading-7
                  "
                >
                  Carefully designed experiences,
                  healing practices, immersive
                  sessions, and transformative
                  moments for complete inner
                  wellbeing.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="space-y-4">
            {items.map((section, index) => (
              <div
                key={index}
                className="
                  relative
                  overflow-hidden
                  rounded-[28px]
                  bg-white/75
                  backdrop-blur-xl
                  border
                  border-white/40
                  shadow-[0_15px_40px_rgba(20,10,0,.05)]
                  p-5
                  transition-all
                  duration-500
                  hover:-translate-y-1
                "
              >
                {/* GLOW */}
                <div
                  className="
                    absolute
                    top-0
                    right-0
                    w-32
                    h-32
                    bg-[#F4D8BE]/20
                    blur-3xl
                    rounded-full
                  "
                />

                <div className="relative z-10">
                  {/* TOP */}
                  <div className="flex items-start gap-4 mb-4">
                    <div
                      className="
                        w-12
                        h-12
                        rounded-full
                        bg-[#FFF4E8]
                        border
                        border-[#F3DDC7]
                        flex
                        items-center
                        justify-center
                        text-xl
                        shrink-0
                      "
                    >
                      {section.icon}
                    </div>

                    <div className="flex-1">
                      <h3
                        className="
                          text-lg
                          md:text-xl
                          font-semibold
                          text-secondary
                          mb-2
                        "
                      >
                        {section.heading}
                      </h3>

                      <div
                        className="
                          w-10
                          h-[2px]
                          bg-[#D8B08B]
                          rounded-full
                        "
                      />
                    </div>
                  </div>

                  {/* POINTS */}
                  <ul className="space-y-3">
                    {section.points.map(
                      (point, idx) => (
                        <li
                          key={idx}
                          className="
                            flex
                            items-start
                            gap-3
                            text-[#5F5751]
                            text-sm
                            leading-7
                          "
                        >
                          <span
                            className="
                              mt-2.5
                              w-2
                              h-2
                              rounded-full
                              bg-primary
                              shrink-0
                            "
                          />

                          <span>{point}</span>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IncludeSection;